import React from "react";
import NavbarUser from "../Components/NavbarUser";
import UserBooking from "../Components/UserBooking";

const UserBookings = () => {
  return (
    <div className="user-bookings-page">
      <NavbarUser />
      <main className="user-bookings-page__main container">
        <UserBooking />
      </main>
    </div>
  );
};

export default UserBookings;
